export default {
      id: "Icon--barchart-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--barchart",
      toString: function () {
        return this.url;
      }
    }